import React from 'react';
import { Timeline, TimelineEvent } from 'react-event-timeline';
import { useQuery } from '@apollo/client';
import { getTimelineComments } from './api';

import { Loader } from '../Loader';
import { ErrorMessage } from '../ErrorMessage';
import { Button } from 'react-bootstrap';

interface Props {
  barcode?: string;
  requestId?: number;
  verifyId?: number;
  getComment?: string;
  po?: number
  setComment?: any;
  style?: any;
}
/**
 *
 * @param props
 */
export const Comments = (props: Props) => {
  const [visible, setVisible] = React.useState(false);
  const { loading, error, data } = useQuery(getTimelineComments, {
    variables: {
      barcode: props.barcode,
      requestId: props.requestId,
      verifyId: Number(props.verifyId),
      po: props.po
    },
  });
  const sortByCreatedDate = (a: any, b: any) => {
    if (new Date(a.createdOn).getTime() > new Date(b.createdOn).getTime()) {
      return -1;
    } else return 1;
  };
  const buttonText = (data: any) => {
    if(visible){
      if(data.length === 0){
        return {text: 'No comments available', disabled: true}
      }else{
        return { text: 'Hide Comments', disabled: false}
      }
    }else{
      if (data.length === 0) {
        return { text: 'No comments available', disabled: true };
      } else {
        return { text: 'Show Comments', disabled: false };
      }
    }
  }
  if (loading) return <Loader />;
  if (error) return <ErrorMessage title={`Problem fetching comments...`} />;
  return (
    <>
      <Button
        variant='danger'
        onClick={() => setVisible(!visible)}
        style={{ width: '100%' }}
        disabled={buttonText(data.getTimelineComments).disabled}>
        {buttonText(data.getTimelineComments).text}
      </Button>
      <div style={{ overflowY: 'auto', marginBottom: '5px', marginTop: '5px', ...props.style }}>
        {visible && (
          <Timeline lineColor='white'>
            {[...data.getTimelineComments].sort(sortByCreatedDate).map(
              (
                commentObject: any,
                index: number //Want a real type here
              ) => (
                <TimelineEvent
                  icon={<span className='fa fa-comment' style={{ color: '#9f9f9f' }} />}
                  bubbleStyle={{ backgroundColor: '#dfdfdf', borderColor: '#afafaf' }}
                  titleStyle={{ fontSize: 14 }}
                  title={`${commentObject.comment}`}
                  key={index}
                  container='card'
                  style={{ marginBottom: '5px' }}
                  cardHeaderStyle={{ backgroundColor: '#efefef', color: '#000' }}
                  createdAt={` ${commentObject.createdBy} - ${new Date(commentObject.createdOn).toLocaleString()}`}
                  // buttons={<Button/>}
                  // subtitleStyle={{ fontSize: 12 }}
                  // contentStyle={{ fontSize: 13 }}
                  // style={{ backgroundColor: '#fff' }}
                  // subtitle={new Date(commentObject.createdOn).toDateString()}
                >
                  {/* {`${commentObject.comment}`} */}
                </TimelineEvent>
              )
            )}
          </Timeline>
        )}
      </div>
    </>
  );
};
